import {Heading, Img} from "./.."
import React from "react";

interface Props {
    className?: string,
    icon?: string;
    text?: string;
    title?: string;
    price?: string;
    description?: string;
    bg?: string;
}

export default function PricingTabs({...props}) {
    return (
        <div
        {...props}
        className={`${props.className} ${props.bg} flex flex-col lg:gap-[100px] gap-[48px] lg:p-10 p-6 rounded-[48px] md:rounded-[32px] sm:rounded-[32px]`}>
            <Img
                src={props.icon}
                alt="icon"
                className="object-contain lg:w-[120px] lg:h-[120px] w-[68px] h-[68px]"/>
            <div className="flex flex-col gap-5 self-stretch sm:gap-4">
                <div className="flex flex-col items-start gap-2">
                    <Heading
                        className={`${props.text} uppercase whitespace-pre-line  leading-[120%]
                        lg:font-semibold lg:text-[24px]
                        font-medium text-[20px]`}>
                        {props.title}
                    </Heading>
                    <Heading
                        size="desktop_body_xl_bold"
                        className={`${props.text} font-extrabold  text-right whitespace-pre-line`}>
                        {props.price}
                    </Heading>
                </div>
                <Heading
                    size="desktop_body_l"
                    className={`${props.text} font-medium whitespace-pre-line`}>
                    {props.description}
                </Heading>
            </div>
        </div>
    )
}